<template>
  <b-nav-item-dropdown class="languages-dropdown" right no-caret>
    <template #button-content>
      <span class="current-lang">
        <flag :iso="currentFlag" class="lang-flag" />
        <span class="lang-code">{{ currentLocale.toUpperCase() }}</span>
        <b-icon icon="chevron-down" class="dropdown-chevron" />
      </span>
    </template>

    <b-dropdown-item
      v-for="lang in languages"
      :key="lang.code"
      @click="changeLocale(lang.code)"
      :active="selectedLanguage(lang.code)"
      class="lang-item"
    >
      <flag :iso="lang.flag" class="lang-flag" />
      <span class="lang-name">{{ lang.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
  export default {
    name: 'LanguagesMenu',

    data () {
      return {
        languages: [
          { code: 'da', flag: 'dk', name: 'Dansk' },
          { code: 'en', flag: 'gb', name: 'English' },
          { code: 'de', flag: 'de', name: 'Deutsch' },
          { code: 'sv', flag: 'se', name: 'Svenska' },
          { code: 'es', flag: 'es', name: 'Español' },
          { code: 'fr', flag: 'fr', name: 'Français' },
          { code: 'nb', flag: 'no', name: 'Norsk' },
          { code: 'it', flag: 'it', name: 'Italiano' },
          { code: 'nl', flag: 'nl', name: 'Nederlands' },
          { code: 'pl', flag: 'pl', name: 'Polski' },
          { code: 'pt', flag: 'pt', name: 'Português' },
          { code: 'fi', flag: 'fi', name: 'Suomi' },
        ]
      }
    },

    computed: {
      currentLocale () {
        return this.$i18n.locale
      },

      currentFlag () {
        const lang = this.languages.find(l => l.code === this.currentLocale)
        return lang ? lang.flag : 'gb'
      }
    },

    methods: {
      selectedLanguage (language) {
        return language === this.$i18n.locale
      },

      changeLocale (language) {
        this.$store.dispatch(this.$_actionTypes.CHANGE_LANGUAGE, { language: language })
          .catch((error) => {
            this.$_notifyError(error, this)
          })
      },
    }
  }
</script>

<style scoped>
/* ── Desktop ────────────────────────────────────────────── */
.languages-dropdown {
  display: flex;
  align-items: center;
}

.current-lang {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 6px;
  transition: background-color 0.15s ease;
}

.current-lang:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.lang-flag {
  font-size: 20px;
  line-height: 1;
  vertical-align: middle;
}

.lang-code {
  font-size: 0.8rem;
  font-weight: 600;
  color: #495057;
  letter-spacing: 0.03em;
}

.dropdown-chevron {
  font-size: 0.65rem;
  color: #6c757d;
  margin-top: 1px;
}

.lang-item {
  display: flex;
  align-items: center;
}

.lang-name {
  margin-left: 8px;
  font-size: 0.9rem;
}

/* ── Mobile (< lg = 992px) ──────────────────────────────── */
@media (max-width: 991.98px) {
  /* Bootstrap forces dropdown-menu to position:static on mobile,
     which pushes it into the document flow and shifts the trigger.
     Keep it absolute so opening the menu doesn't affect the trigger layout. */
  .languages-dropdown {
    position: relative;
  }

  .languages-dropdown ::v-deep .dropdown-menu {
    position: absolute !important;
    left: 0 !important;
    right: auto !important;
    top: 100% !important;
    min-width: 160px;
    width: auto;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    z-index: 1050;
  }

  /* Align trigger to the left, no extra padding */
  .languages-dropdown ::v-deep > .nav-link {
    padding-left: 0 !important;
    justify-content: flex-start !important;
  }
}
</style>
